module.exports = __webpack_public_path__ + "static/img/ry3.2df9316.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutLanshu/ry3.jpg
// module id = FbBf
// module chunks = 0